// src/app/shared/base-providers.ts
import { EnvironmentProviders, makeEnvironmentProviders, inject } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AuthService } from '../../services/auth.service';

export const BaseProviders: EnvironmentProviders = makeEnvironmentProviders([
  provideHttpClient(
    withInterceptors([
      (req, next) => {
        // Skip token if the URL matches /api/auth/*
        const shouldSkip = /\/api\/auth\//.test(req.url);
        if (shouldSkip) {
          return next(req);
        }

        const authService = inject(AuthService);
        const token = authService.token();
        console.log('Token (attached):', token);

        if (token) {
          const authReq = req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`
            }
          });
          return next(authReq);
        }

        return next(req);
      }
    ])
  ),
  provideAnimations()
]);
